<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM13 9.414V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V9.416L9.70711 10.7071L9.6129 10.7903C9.22061 11.0953 8.65338 11.0676 8.29289 10.7071C7.90237 10.3166 7.90237 9.68342 8.29289 9.29289L11.2929 6.29289L11.3746 6.21969L11.4793 6.146L11.5768 6.09367L11.6879 6.04974L11.7993 6.02024L11.9248 6.00279L12 6L12.1181 6.00691L12.266 6.03585L12.3713 6.07123L12.4841 6.12467L12.5953 6.19633L12.6631 6.2515L12.7071 6.29289L15.7071 9.29289L15.7903 9.3871C16.0953 9.77939 16.0676 10.3466 15.7071 10.7071L15.6129 10.7903L15.5114 10.8596C15.1275 11.0884 14.6233 11.0375 14.2929 10.7071L13 9.414Z"
    fill="currentColor"
  />
</svg>
